module.exports = __webpack_public_path__ + "static/img/card.2ebd6cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card.jpg
// module id = dq/c
// module chunks = 0